var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Menu extends Component {
    constructor() {
        super('Menu', false);
        this.headerHeight = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('scroll', () => {
                this.spy();
            });
            $('.btn-open-carousel').on('click', (event, button) => {
                if ($(window).width() >= 992 && button.parents('.index').length > 0)
                    return;
                event.preventDefault();
                $('.menu-main').addClass('d-none').removeClass('d-flex');
                $('.menu-project').addClass('d-flex').removeClass('d-none');
            });
            $('.btn-close-project').on('click', (event, button) => {
                event.preventDefault();
                $('.menu-main').addClass('d-flex').removeClass('d-none');
                $('.menu-project').addClass('d-none').removeClass('d-flex');
                $('.btn-open-project-info').removeClass('d-none');
                $('.btn-open-project-carousel').addClass('d-none');
            });
            $('.btn-open-project-info').on('click', (event, button) => {
                event.preventDefault();
                $('.btn-open-project-info').addClass('d-none');
                $('.btn-open-project-carousel').removeClass('d-none');
            });
            $('.btn-open-project-carousel').on('click', (event, button) => {
                event.preventDefault();
                $('.btn-open-project-info').removeClass('d-none');
                $('.btn-open-project-carousel').addClass('d-none');
            });
            this.spy();
            this.success();
        });
    }
    spy() {
        // Desktop
        const projectsSectionTop = $('.projects').viewportPosition().y;
        const indexSectionTop = $('.index').viewportPosition().y;
        if (projectsSectionTop < $(window).height() / 2 && indexSectionTop > $(window).height()) {
            $('#scroll-to-index').removeClass('is-offscreen');
        }
        else {
            $('#scroll-to-index').addClass('is-offscreen');
        }
        // Mobile
        const indexMobileTop = $('#index-mobile').viewportPosition().y;
        if (indexMobileTop <= 1) {
            $('.btn-scroll-to-index').addClass('d-none');
            $('.btn-scroll-to-projects').removeClass('d-none');
        }
        else {
            $('.btn-scroll-to-index').removeClass('d-none');
            $('.btn-scroll-to-projects').addClass('d-none');
        }
    }
}
